import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import PeopleIcon from '@mui/icons-material/People';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './User.css';

const UserCreate = () => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userName, setUserName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [email, setEmail] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, token]);

    useEffect(() => {
        const generated = `${companyId}${firstName.toLowerCase()}_${lastName.toLowerCase()}`;
        setUserName(generated.slice(0, 12));
    }, [firstName, lastName]);

    const submitData = (e) => {
        e.preventDefault();
        if (!firstName) { setErrorMessage('First Name is required!'); return; }
        if (!lastName) { setErrorMessage('Last Name is required!'); return; }
        if (!contactNumber) { setErrorMessage('Contact Number is required!'); return; }
        if (!email) { setErrorMessage('Email is required!'); return; }

        postData('UserApi', {
            FirstName: firstName, LastName: lastName, UserName: userName,
            Email: email, ContactNumber: contactNumber,
            CreatedBy: userId, CompanyId: companyId, CreatedDate: new Date(),
        }, token)
            .then(() => {
                setSuccessMessage('User created successfully!');
                setErrorMessage('');
                history.push('/UserIndex');
            })
            .catch((e) => { console.error('User Create error:', e); setErrorMessage('Error creating user.'); });
    };

    return (
        <div className="user-container">
            <div className="user-header-card">
                <div className="user-header-content">
                    <div className="user-title-section">
                        <span className="user-title-icon"><PeopleIcon fontSize="small" /></span>
                        <h1 className="user-title">User Create</h1>
                    </div>
                    <div className="user-header-actions">
                        <button className="usr-btn usr-btn-create" onClick={submitData}>
                            <SaveIcon style={{ fontSize: 14 }} />&nbsp;Save
                        </button>
                        <Link to="/UserIndex" className="usr-btn usr-btn-cancel">
                            <ArrowBackIcon style={{ fontSize: 14 }} />&nbsp;Back
                        </Link>
                    </div>
                </div>
            </div>

            {errorMessage && <div className="user-alert user-alert-error">{errorMessage}</div>}
            {successMessage && <div className="user-alert user-alert-success">{successMessage}</div>}

            <div className="user-form-card">
                <p className="user-form-section-title">User Information</p>
                <div className="user-form-row">
                    <div className="user-form-group">
                        <label className="user-label">First Name <span className="required">*</span></label>
                        <input className="user-input" type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="Enter first name" maxLength={30} />
                    </div>
                    <div className="user-form-group">
                        <label className="user-label">Last Name <span className="required">*</span></label>
                        <input className="user-input" type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Enter last name" maxLength={30} />
                    </div>
                    <div className="user-form-group">
                        <label className="user-label">User Name</label>
                        <input className="user-input" type="text" value={userName} readOnly placeholder="Auto-generated" />
                    </div>
                </div>
                <div className="user-form-row">
                    <div className="user-form-group">
                        <label className="user-label">Contact Number <span className="required">*</span></label>
                        <input className="user-input" type="text" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} placeholder="Enter contact number" maxLength={15} />
                    </div>
                    <div className="user-form-group">
                        <label className="user-label">Email <span className="required">*</span></label>
                        <input className="user-input" type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter email" maxLength={40} />
                    </div>
                    <div className="user-form-group" />
                </div>
            </div>
        </div>
    );
};

export default UserCreate;
